export enum COLLECTIONS {
	AGENCIES = 'agencies',
	BUSINESSSECTORS = 'business_sectors',
	COMPANIES = 'companies',
	JOBS = 'jobs',
	MISSIONS = 'missions',
	USERS = 'users',
	UNAVAILABILITIES = 'unavailabilities',
	CANDIDATES = 'candidates',
}
